import { MediaclipService } from 'app/services/mediaclip.service';
import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../bb-filters/bb-filters.component';
import { FilterSetService, FilterSet } from '../../../services/filter-set.service';

@Component({
	selector: 'bb-mediaclip-selector',
	templateUrl: './bb-mediaclip-selector.component.html',
	styleUrls: ['./bb-mediaclip-selector.component.scss']
})

export class BbMediaclipSelectorComponent implements OnInit, OnDestroy {
	@Input() bbTableService: BbTableService;
	@Input() mediaTypes: string[];

	@Output() selected: EventEmitter<TableRow> = new EventEmitter<TableRow>();
	@Output() canceled: EventEmitter<null> = new EventEmitter();

	filterConfig: BbFilterConfiguration;
	subscriptions: Subscription;
	rows: TableRow[] = [];
	selectedMediaclipFromTable: TableRow;

	constructor(
		private translate: TranslateService,
		private filterSetService: FilterSetService,
		private mediaclipService: MediaclipService
	) {
		this.filterConfig = {
			search: true,
			linkedToUrl: false,
			filters: this.mediaclipService.getMediaSelectorFilterConfig()
		};

		this.filterSetService.setLinkedToUrl(false);
		this.filterSetService.setEntity('commonclip');

		this.subscriptions = new Subscription();
	}

	ngOnInit() {
		let addMediatypeFilter = false;
		let baseFilterSet: FilterSet;

		if (this.mediaTypes) {
			baseFilterSet = [
				{
					filters: [{
						type: 'commonclip',
						field: 'mediatype',
						operator: 'is',
						value: this.mediaTypes
					}]
				}
			];

			if (this.mediaTypes.length > 1) {
				addMediatypeFilter = true;
			}
			this.filterSetService.setBaseFilterSet(baseFilterSet);
		} else {
			addMediatypeFilter = true;
		}

		if (addMediatypeFilter) {
			this.filterConfig.filters.unshift(
				{
					property: 'mediatype',
					label: this.translate.instant('MEDIATYPE'),
					type: 'select'
				}
			);
		}

		this.bbTableService
			.setConfigurable(false)
			.setSelect(BbTableSelectOption.single)
			.setEntity('commonclip')
			.setQuery('')
			.setBaseFilterSet(baseFilterSet)
			.setLimit(10)
			.getRows(false);

		this.subscriptions.add(this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => {
			if (rows) {
				this.rows = rows;
			}
		}));

		this.subscriptions.add(this.bbTableService.rowDoubleClickedObservable.subscribe((row: TableRow) => {
			if (row) {
				this.selectedMediaclipFromTable = row;
			}
			this.selectClicked();
		}));

		this.subscriptions.add(this.bbTableService.rowsSelectedObservable.subscribe((rows: TableRow[]) => {
			if (rows && rows.length > 0) {
				this.selectedMediaclipFromTable = rows[0];
			}
		}));
	}

	cancelClicked() {
		this.canceled.emit();
	}

	selectClicked() {
		this.selected.emit(this.selectedMediaclipFromTable);
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}
}
